import zipcodes from 'zipcodes';

const uniqueCityNames = [...new Set(zipcodes.lookupByState('AR').map((z) => z.city))].sort((a, b) =>
  a.localeCompare(b)
);

export const ARKANSAS_CITIES = uniqueCityNames.map((city) => ({ id: city, city }));
